import { render, staticRenderFns } from "./DriverModifyDialog.vue?vue&type=template&id=63959e84&scoped=true"
import script from "./DriverModifyDialog.vue?vue&type=script&lang=js"
export * from "./DriverModifyDialog.vue?vue&type=script&lang=js"
import style0 from "./DriverModifyDialog.vue?vue&type=style&index=0&id=63959e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63959e84",
  null
  
)

export default component.exports